import { colours } from '@headbox-ui/themes'

const { brick, grey, white } = colours

export const topNav = {
  border: 0,
  height: 64,
  lineHeight: '63px'
}

export const subNav = {
  border: 0,
  fontSize: '14px',
  height: 40,
  lineHeight: '39px',
  marginLeft: '-40px',
  maxWidth: 1278,
  width: '100%'
}

export const subNavWrapper = {
  alignItems: 'center',
  borderBottom: `${grey[99] as string} 1px solid`,
  backgroundColor: white,
  display: 'flex',
  justifyContent: 'center',
  padding: '0 40px',
  position: 'fixed' as 'fixed',
  top: '65px',
  width: '100%',
  zIndex: 100
}

export const adminPink = {
  backgroundColor: '#F7E9E9'
}

export const drawer = {
  padding: '48px 0'
}

export const button = {
  backgroundColor: brick[600],
  borderColor: brick[600]
}
